import React from "react";
import PropTypes from "prop-types";
import styles from '../styles/Youtube.module.css';

function youtube_parser(url){
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = url.match(regExp);
    return (match&&match[7].length==11)? match[7] : false;
}

const YoutubeEmbed = ({ embedId, embedUrl }) => {
    if(embedUrl){
        return <div className={styles.videoResponsive}>
        <iframe
          width="853"
          height="480"
          src={embedUrl}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Embedded youtube"
        />
      </div>
    }
    if(embedId){
        if(embedId.includes('http')){
            embedId = youtube_parser(embedId);
        }

        return <div className={styles.videoResponsive}>
        <iframe
          width="853"
          height="480"
          src={`https://www.youtube.com/embed/${embedId}`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="Embedded youtube"
        />
      </div>
    }
    };

YoutubeEmbed.propTypes = {
  embedId: PropTypes.string.isRequired
};

export default YoutubeEmbed;